import * as Rx from 'rxjs';

interface IRoute {
  url: string;
}

interface ITitlePage {
  titlePage: string[];
}

class RoutesService {
  private routes$ = new Rx.BehaviorSubject({ url: '' });

  get(): Rx.Observable<IRoute> {
    return this.routes$.asObservable();
  }

  set(url: string) {
    this.routes$.next({ url });
  }

  unset() {
    this.routes$.unsubscribe();
  }
}

class TitlePageService {
  private titlePage$ = new Rx.BehaviorSubject({ titlePage: [''] });

  get(): Rx.Observable<ITitlePage> {
    return this.titlePage$.asObservable();
  }

  set(titlePage: string[]) {
    this.titlePage$.next({ titlePage });
  }

  unset() {
    this.titlePage$.unsubscribe();
  }
}

export const routesService = new RoutesService();
export const titlePageService = new TitlePageService();
